<template>
    <PopoverRight ref="popoverMenu" width="600px">
        <div class="popover-slider-bar">
            <h1 class="bar-title">新增代理商</h1>
            <el-form class="form-container" :model="factorInfo" :rules="factorRules" ref="userInfoForm">
                <h1 class="bar-sub-title">基本信息</h1>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">代理商名称</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="name">
                            <el-input placeholder="请输入代理商名称" v-model="factorInfo.name">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">联系人</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="contacts">
                            <el-input placeholder="请输入联系人" v-model="factorInfo.contacts">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">联系号码</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="contact_number">
                            <el-input placeholder="请输入联系号码" v-model="factorInfo.contact_number">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">备注</span>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="remark">
                            <el-input placeholder="请输入备注" v-model="factorInfo.remark">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <h1 class="bar-sub-title">签约状管理及好房云推送管理</h1>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">签约状态</span>
                        <label class="warn">*</label>
                    </div>
                    <div style="line-height: 36px;">
                        <el-switch v-model="sign_status" active-color="#13ce66" :active-value="1" :inactive-value="0"
                            active-text="已签约" inactive-text="未签约">
                        </el-switch>
                    </div>
                </div>
                <div class="form-item" v-if="sign_status == 1">
                    <div class="form-label">
                        <span class="label">添加签约站点</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item prop="checkedSites">
                            <site-auto-complete :factor-id="1" v-model="factorInfo.site_selected" @change="changeSites">
                            </site-auto-complete>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-select-checked-container" v-if="sign_status == 1">
                    <p v-for="(tag, key) in checkedSites" :key="key" class="item">
                        {{tag.name}}
                        <i class="el-icon-close" @click.stop.prevent="removeChecked(key)"></i>
                    </p>
                </div>
                <div class="form-select-site" v-if="sign_status == 1">
                    <el-card class="box-card" v-for="(item, key) in checkedSites" :key="key">
                        <div>
                            <span style="font-size:18px;margin-left:30px;font-weight: bold;">{{item.name}}</span>
                            <i class="el-icon-close" @click.prevent="removeChecked(key)"></i>
                        </div>
                        <div class="form-item">
                            <div class="form-label">
                                <span class="label">签约时间</span>
                                <label class="warn">*</label>
                            </div>
                            <div class="form-input-item">
                                <el-form-item label="">
                                    <el-date-picker v-model="checkedSites[key].signDate" type="daterange"
                                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                                    </el-date-picker>
                                </el-form-item>
                            </div>
                        </div>
                    </el-card>
                </div>
                <div class="form-button">
                    <el-button type="primary" v-preventReClick @click="submitForm('userInfoForm')">保 存</el-button>
                    <el-button type="info" plain @click.stop.prevent="hide">取 消</el-button>
                </div>
            </el-form>
        </div>
    </PopoverRight>
</template>

<script>
import PopoverRight from '@/components/popoverRight/index'
import { createFactor, modifyFactorStatus, modifyFactorSites } from '@/service/user'
import { validateChat, validateMobile } from '@/utils/validate'
import SiteAutoComplete from "../../../../components/auto-complete/site-auto-complete";
import {getUserInfo} from '@/utils/auth'

export default {
    name: "add",
    components: {
        PopoverRight,
        SiteAutoComplete
    },
    props: {
        callback: Function
    },
    methods: {
        changeSites(id) {
            let site = this.data.find(data => data.id === id)
            if (site && this.checkedSites.findIndex(data => data.id === id) < 0) {
                this.$set(site, 'signDate', '');
                this.checkedSites.push(site)
            }

        },
        removeChecked(index) {
            this.checkedSites.splice(index, 1)
            this.factorInfo.site_selected = this.checkedSites.length > 0 ? this.checkedSites[0].id : ''
        },
        open() {
            this.$refs.popoverMenu && this.$refs.popoverMenu.open()
        },
        /** 关闭右侧悬浮层 */
        hide() {
            this.$refs.popoverMenu && this.$refs.popoverMenu.hide()
            this.resetForm()
            this.$refs.userInfoForm && this.$refs.userInfoForm.clearValidate()
        },
        resetForm() {
            this.factorInfo = {
                id: 0,
                name: '',
                contacts: '',
                contact_number: '',
                sites: [],
                site_selected: '',
            }
            this.checkedSites = [],
                this.sign_status = 0
        },
        submitForm(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    this.timeStatus = true;
                    this.checkedSites.forEach(el => {
                        if (!el.signDate) {
                            this.timeStatus = false;
                            return false;
                        }
                    })
                    if (!this.timeStatus) {
                        this.$message({
                            message: '签约时间不能为空！',
                            type: 'error',
                            duration: 3 * 1000
                        })
                        return false;
                    }
                    let status = 0
                    let query = {
                        name: this.factorInfo.name,
                        contacts: this.factorInfo.contacts,
                        contact_number: this.factorInfo.contact_number,
                        remark: this.factorInfo.remark,
                    }
                    await createFactor(query).then(async (data) => {
                        status = 1
                        this.factorInfo.id = data.id
                        if (this.sign_status === 1 && status && this.factorInfo.id) {
                            query = {
                                "status": 1
                            }
                            status = 0
                            modifyFactorStatus(this.factorInfo.id, query).then((data) => {
                                status = 1;
                                if (!status) {
                                    return false;
                                }
                                let sites = [];
                                this.checkedSites.forEach(el => {
                                    let site = {};
                                    site.id = el.id;
                                    site.sign_start_time = new Date(el.signDate[0]).getTime() / 1000;
                                    site.sign_end_time = new Date(el.signDate[1]).getTime() / 1000 + 86400 - 1;
                                    sites.push(site)
                                });
                                let query = {};
                                query.sites = sites
                                modifyFactorSites(this.factorInfo.id, query).then((data) => {
                                    this.$message({
                                        message: '站点添加成功',
                                        type: 'success',
                                        duration: 3 * 1000
                                    })
                                    if (status == 1) {
                                        this.resetForm()
                                        this.hide()
                                        this.callback && this.callback();
                                    }

                                }).catch(err => {
                                    this.$message({
                                        message: err.message || '站点添加失败',
                                        type: 'error',
                                        duration: 3 * 1000
                                    })
                                    // if (status == 1) {
                                    //     this.resetForm()
                                    //     this.hide()
                                    //     this.callback && this.callback();
                                    // }
                                })
                            }).catch(err => {
                                this.$message({
                                    message: err.message || '状态修改失败',
                                    type: 'error',
                                    duration: 3 * 1000
                                })
                            })
                        } else {
                            this.resetForm()
                            this.hide()
                            this.callback && this.callback();
                        }
                    }).catch(err => {
                        this.$message({
                            message: err.message || '添加失败',
                            type: 'error',
                            duration: 3 * 1000
                        })
                    })
                } else {
                    return false
                }
            })
        },
    },
    data() {
        let validDate = (rule, value, callback) => {
            if (!value || !value[0] || !value[1]) {
                callback(new Error("请选择时间"))
            } else if (value[0] >= value[1]) {
                callback(new Error("结束时间必须大于开始时间"))
            } else {
                callback()
            }
        }
        let validateName = (rule, value, callback) => {
            if (!/^[a-zA-Z0-9\u4e00-\u9fa5\-_]*$/.test(value)) {
                callback(new Error(rule.message))
            } else {
                callback()
            }
        }
        let validateSite = (rule, value, callback) => {
            if (this.checkedSites.length <= 0) {
                callback(new Error(rule.message))
            } else {
                callback()
            }
        }
        return {
            factorInfo: {
                id: 0,
                name: '',
                contacts: '',
                contact_number: '',
                site_selected: '',
                sites: [],
            },
            checkedSites: [],
            timeStatus: true,
            sign_status: 0,
            data: [
            ],
            factorRules: {
                name: [
                    { required: true, message: '请输入代理商名称', trigger: 'blur' },
                    { min: 6, max: 20, message: '代理商名称长度为6-20个字符之间', trigger: 'blur' },
                ],
                contacts: [
                    { required: true, message: '请输入联系人', trigger: 'blur' },
                    { min: 2, max: 20, message: '联系人长度为2-20个字符之间', trigger: 'blur' },
                    { validator: validateName, trigger: 'blur', message: '代理商名称只能包含-_大小写字母、数字、中文' }
                ],
                contact_number: [
                    { required: true, message: '请填写联系人号码', trigger: 'blur' },
                    { validator: validateMobile, trigger: 'blur', result: '联系号码' }
                ],
                checkedSites: [
                    { validator: validateSite, message: '请选择站点', trigger: 'change' },
                ],
                signDate: [
                    { validator: validDate, trigger: 'change' }
                ],
                remark: [
                    { min: 6, max: 255, message: '请填写长度在 6 到 255 个字符备注', trigger: 'blur' }
                ],
            },
            user:null
        }
    },
    mounted(){
        this.user = JSON.parse(getUserInfo())
    }
}
</script>

<style scoped>
.bar-sub-title {
    font-size: 15px;
    background: #fafafa;
    padding: 10px 5px;
    margin: 10px 0;
}
</style>
